import {createSelector} from '@reduxjs/toolkit';
import {EventFamilyInfo} from 'src/openapi/models/EventFamilyInfo';
import {RootState} from 'src/store/store';

export const getEventFamilies = (state: RootState): EventFamilyInfo[] =>
    state.eventFamilies.data;

export const isEventFamiliesLoaded = (state: RootState): boolean =>
    state.eventFamilies.isLoaded;

export const getEventFamilyNames = createSelector(
    [getEventFamilies],
    families => families.map(family => family.name).toSorted(),
);
